export const common = {
  notFound: {
    title: "页面未找到",
    subtitle: "抱歉,您访问的页面不存在或已被移除",
    description: "您可以返回首页或尝试其他页面",
    backHome: "返回首页",
    goBack: "返回上一页"
  },
  taskRecord: {
    participationYear: "参与年份",
    selectYear: "选择年",
    questionnaireName: "问卷名称",
    taskNumber: "任务编号",
    returnTime: "返回时间",
    loadMore: "触底加载更多",
    noMoreData: "已经到底了~",
    noData: "暂无数据",
    status: "状态",
    exitedMidway: "中途退出",
    screenedOut: "被甄别",
    quotaFull: "配额满",
    completedSuccessfully: "成功完成",
    auditRejected: "审核拒绝",
    qualityScreening: "质量甄别"
  },
  taskDetails: {
    instantReward: "即时奖励",
    unifiedReward: "统一奖励"
  },
  task: {
    recommendedSurveys: "推荐问卷",
    topicDiscussion: "话题讨论",
    multipleCompletion: "多次完成",
    participateNow: "立即参与",
    noData: "暂无数据",
    hideConfirmTitle: "提示",
    hideConfirmMessage: "此调查，如果提示您参加过或者您不愿意参加，您可以隐藏本项目。隐藏后，您将无法再参与本项目，请确认是否隐藏？",
    confirmButton: "确定",
    cancelButton: "取消",
    hideSuccess: "隐藏成功"
  },
  reward: {
    completed: "完成",
    screenedOut: "被甄别",
    quotaFull: "配额满",
    successComplete: "您已成功完成!",
    regretScreened: "很遗憾，您被甄别了！",
    regretQuotaFull: "很遗憾，配额满了！",
    goldCoin: "金币",
    estimatedGold: "预计获得金币",
    completeTip1: "根据您的作答信息，您已经完成了全部作答问卷。感谢您的积极参与！",
    completeTip2: "根据您的作答信息，已经被甄别了。 感谢您的积极参与！",
    completeTip3: "根据您的作答信息，已经配额满了。 感谢您的积极参与！",
    auditTip: "由于本项目是'统一奖励'的问卷，需要人工审核通后统一发放，预计审核时间1-4周的时间，请耐心等待。",
    moreRewards: "更多奖励等你领取",
    canExchange: "您已经可以兑换{giftName}！",
    needMoreCoins: "还差{coins}金币可兑换{giftName}！",
    needMoreCoinsDefault: "还差500金币可兑换{giftName}！",
    recommendForYou: "为你推荐",
    moreSurveys: "更多问卷等你来答",
    increaseCredit: "增加信用值",
    inviteFriends: "推荐好友得金币",
    goToAnswer: "去答题",
    goToRecommend: "去推荐",
    continueLightUp: "继续点亮"
  },
  register: {
    smsCode: "短信验证码",
    getCode: "获取验证码",
    getAfterSeconds: "{seconds}s 后获取",
    previousStep: "上一步"
  },
  redemptionHistory: {
    clickToClaim: "点击领取",
    claimed: "已领取",
    loadMore: "触底加载更多",
    noMoreData: "已经到底了~",
    noData: "暂无数据",
    transactionTime: "交易时间",
    orderNumber: "订单号",
    prizeName: "奖品名称",
    claimStatus: "领取状态",
    pendingConfirmation: "等待确认",
    pendingReview: "等待审核",
    reviewApproved: "审核通过",
    reviewRejected: "审核拒绝",
    orderCancelled: "订单取消",
    orderCompleted: "订单完成"
  },
  notice: {
    messageTitle: "消息标题",
    readStatus: "是否已读",
    sendTime: "发送时间",
    messageContent: "消息内容",
    operation: "操作",
    read: "已读",
    unread: "未读",
    view: "查看",
    delete: "删除",
    messageDetail: "消息详情",
    close: "关闭",
    loadMore: "触底加载更多",
    noMoreData: "已经到底了~",
    noData: "暂无数据"
  },
  latestNews: {
    latestAnnouncement: "最新公告",
    home: "首页",
    allAnnouncements: "全部公告",
    announcementDetail: "公告详情",
    previousArticle: "上一篇",
    nextArticle: "下一篇",
    publishTime: "发布时间",
    announcementTitle: "公告标题",
    operation: "操作",
    viewDetail: "查看详情",
    publishTimeLabel: "发布时间：",
    backToAllAnnouncements: "← 返回全部公告",
    backToAnnouncements: "← 全部公告"
  }
};
